import { render, staticRenderFns } from "./OwnerDetails.vue?vue&type=template&id=7987a2d4&scoped=true"
import script from "./OwnerDetails.vue?vue&type=script&lang=js"
export * from "./OwnerDetails.vue?vue&type=script&lang=js"
import style0 from "./OwnerDetails.vue?vue&type=style&index=0&id=7987a2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7987a2d4",
  null
  
)

export default component.exports